<template>
  <div>
    <reviselogword-mess v-transition></reviselogword-mess>
  </div>
</template>

<script>
import ReviselogwordMess from './components/Mess'
export default {
  name: 'Reviselogword',
  components: {
    ReviselogwordMess
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/revise_logon_password/Reviselogword.vue